const mathnationURL =
   (
    !(
      window.location.host.includes(
        'stem.dev.stemscopes-v4-dev.aws.acceleratelearning.com'
      ) && window.location.host.startsWith('local.')
    )
      ? '/mathnation'
      : ''
  );


export default mathnationURL;
